import { AuthPayload, AuthResponse } from "@/features/auth";
import {enqueueSnackbar} from "notistack";
import { apiClient } from "./client";

export const authRequest = async (
  url: "/api/users/login" | "/api/users/register" | "/api/users/verify" | "/api/users/change-password" | "/api/users/regenerate-code",
  payload?: AuthPayload,
  token?: string
): Promise<AuthResponse> => {
  try {
    const data = await apiClient(url, "post", payload, token);

    if (data.success) {
      return data;
    } else {
      enqueueSnackbar(data.response?.data?.error || "Ошибка авторизации", {
        variant: "error",
      });
      return data;
    }
  } catch (error: any) {
    return {success: false, error: error?.error};
  }
};
